
























































































































































































































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import AreaChart from "@/components/AreaChart.vue";
import LineChart from "@/components/LineChart.vue";
import TutorialMatchingUpload from "@/components/TutorialMatchingUpload.vue";
import MatchingAdminTable from "@/components/MatchingAdminTable.vue";
import { Watch } from "vue-property-decorator";

export interface Tutorial {
  id?: string;
  name: string;
  responsible_tutor: string;
  day: string;
  start: string;
  end: string;
  capacity?: string;
  link?: string;
  room?: string;
  format?: string;
  course?: string | null;
  password?: string;
  programming_tutorial?: boolean;
}

export interface Course {
  id?: string;
  startDate: string;
  endDate: string;
  name: string;
}

type TutorialTimeslot = {
  day: string;
  start: string;
  end: string;
  format: "online" | "presence";
  capacity: number;
};

@Component({
  components: {
    LineChart,
    AreaChart,
    TutorialMatchingUpload,
    MatchingAdminTable,
  },
})
export default class TutorialsAdmin extends Vue {
  //tutorials and tutorials assignment
  private tutors: string[] = [];
  private timeSlot: string[][] = [];
  private selection: string[][] = [];
  private tutorials: Tutorial[] = [];
  private tutorialsSelected: { [key: string]: Tutorial[] } = {};
  private participantsSemester: any[] = [];
  private tutorList: any[] = [];

  //tutor and tutorial assignment using matching
  private timeslots: TutorialTimeslot[] = [];
  public matchings: any[] = [];

  //attribute for displaying elements
  private showSelectionResult = { value: false };
  private showTutorialGeneration = { value: false, method: 0 };
  private showAssignmentUpload = { value: false };
  private isChart = { value: false };

  // new tutorial
  private tutor = "";
  private dayTutorial1 = "";
  private timeTutorial1 = "";
  private formatTutorial1 = "";
  private locationTutorial1 = "";
  private linkTutorial1 = "";
  private isProgrammingTutorial = false;
  private createdTutorials: Tutorial[] = [];

  // files
  private tutorsFile: File | undefined = undefined;
  private tutorialsFile: File | undefined = undefined;
  private assignmentsFile: File | undefined = undefined;
  private allInOneFile: File | undefined = undefined;

  //course
  // TODO: Change course mechanism here, only course of this subject should be display here!
  private currentCourse: Course[] = [];
  get latestCourse(): Course {
    const selectedCourse = localStorage.getItem("selectedCourse");
    if (selectedCourse) {
      const course = this.currentCourse.find((x) => x.id == selectedCourse);
      if (course) {
        return course;
      } else {
        return this.currentCourse[this.currentCourse.length - 1];
      }
    } else {
      return this.currentCourse[this.currentCourse.length - 1];
    }
  }

  private selectedCourse = localStorage.getItem("selectedCourse");

  @Watch("selectedCourse")
  saveSelectedCourse(value: string, _: string) {
    localStorage.setItem("selectedCourse", value);
    location.reload();
  }

  toCourseView(id: string) {
    this.$router.push({
      name: "tutorials.admin.course",
      params: {
        id: id,
      },
    });
  }

  deleteCourse(id: string, index: number) {
    if (confirm(this.$t("coursesAdmin.confirm") + " " + id + "?")) {
      this.$axios.delete("courses/" + id).then((req) => {
        this.currentCourse.splice(index, 1);
        if (this.selectedCourse == id) {
          if (this.currentCourse.length) {
            if ("id" in this.currentCourse[this.currentCourse.length - 1]) {
              const newCourse: string | null =
                this.currentCourse[
                  this.currentCourse.length - 1
                ].id?.toString() || "";
              if (newCourse) {
                this.selectedCourse = newCourse;
              }
            } else {
              this.selectedCourse = "";
            }
          } else {
            this.selectedCourse = "";
          }
        }
        alert(this.$t("coursesAdmin.alert"));
      });
    }
  }

  deleteTutorial(id: string) {
    if (confirm(this.$t("course.confirm") + " " + id + "?")) {
      this.$axios
        .delete("tutorials/" + id)
        .then((req) => {
          this.tutorials = this.tutorials.filter((t) => t.id != id);
        })
        .catch((err) => {
          alert(this.$t("course.alertFailed"));
        });
    }
  }

  toTutorProfile(tutor: string) {
    this.$router.push({
      name: "tutorials.profile.username",
      params: { username: tutor },
    });
  }

  // create new course
  newCourseName: any = { value: null };
  newCourseStartDate: any = { value: null };
  newCourseEndDate: any = { value: null };
  newCourseUrl: any = { value: null };

  saveNewCourse() {
    const name = this.newCourseName.value;
    const startDate = new Date(this.newCourseStartDate.value);
    const endDate = new Date(this.newCourseEndDate.value);
    const url = this.newCourseUrl.value;
    if (startDate && endDate && name && this.noDuplicatedName(name)) {
      if (startDate instanceof Date && endDate instanceof Date) {
        if (
          (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24) >=
          5
        ) {
          const params = {
            /* eslint-disable @typescript-eslint/camelcase */
            start_date: startDate.toISOString().slice(0, 10),
            end_date: endDate.toISOString().slice(0, 10),
            gitlab_url: url,
            /* eslint-enable @typescript-eslint/camelcase */
            name: name,
          };
          this.$axios.post("courses/", params).then((req) => {
            this.newCourseName.value = "";
            this.newCourseStartDate.value = "";
            this.newCourseEndDate.value = "";
            this.newCourseUrl.value = "";
            this.$axios.get("courses").then((req) => {
              const courseData = req.data;
              this.currentCourse = [];
              if (courseData instanceof Array) {
                for (let i = 0; i < courseData.length; i++) {
                  this.currentCourse.push(courseData[i]);
                }
              } else {
                this.currentCourse.push(courseData);
              }
            });
            location.reload();
          });
        } else {
          alert(this.$t("coursesAdmin.alertDate"));
        }
      }
    } else {
      alert(this.$t("coursesAdmin.alertInput"));
    }
  }

  noDuplicatedName(name: string) {
    const courseName: string[] = this.currentCourse.map((c) => c["name"]);
    return courseName.indexOf(name) < 0;
  }

  getTutorItems() {
    return this.tutorList.map((t) => t.username);
  }

  getTimeSlots() {
    return [
      { text: "8:00 - 10:00", value: "08" },
      { text: "10:00 - 12:00", value: "10" },
      { text: "12:00 - 14:00", value: "12" },
      { text: "14:00 - 16:00", value: "14" },
      { text: "16:00 - 18:00", value: "16" },
    ];
  }

  getFormats() {
    return [
      { text: "online", value: "ONLINE" },
      { text: "präsenz", value: "PRESENCE" },
    ];
  }

  submitTutorials() {
    if (this.tutor && this.timeTutorial1 && this.dayTutorial1) {
      this.getTutorialOrder(
        this.dayTutorial1,
        this.timeTutorial1,
        this.locationTutorial1,
        this.linkTutorial1,
        this.formatTutorial1,
        this.isProgrammingTutorial
      ).then((req) => {
        console.log(this.createdTutorials);
        if (this.createdTutorials.length) {
          this.$axios
            .post(
              "tutorials/",
              this.createdTutorials[this.createdTutorials.length - 1]
            )
            .then((ret) => {
              this.tutorials.push(
                this.createdTutorials[this.createdTutorials.length - 1]
              );
              this.createdTutorials = [];
            })
            .catch((err) => alert(err));
        }
      });
    } else {
      alert("Information of the tutorial is not sufficient");
    }
  }

  async getTutorialOrder(
    day: string,
    start: string,
    location: string,
    link: string,
    format: string,
    programmingTut: boolean
  ) {
    await this.$axios
      .get("tutorials/get_tutorial_order", {
        params: { day: day, start: start + ":00" },
      })
      .then((req) => {
        if (req.data instanceof Array) {
          const count = req.data.length + 1;
          let alreadyExists = 0;
          if (req.data.length > 0) {
            alreadyExists = req.data
              .flatMap((t) => t["responsible_tutor"])
              .filter((t) => t == this.tutor).length;
          }
          if (alreadyExists == 0 && count <= 26) {
            const name = (count + 9).toString(36).toUpperCase();
            const startTime = start + ":00";
            const startName = start + "00";
            const end = parseInt(start) + 2;
            const endTime = end + ":00";
            const tutor = this.tutor;
            const newTutorial: Tutorial = {
              name: day + "-" + startName + "-" + name,
              start: startTime,
              end: endTime,
              // eslint-disable-next-line @typescript-eslint/camelcase
              responsible_tutor: tutor,
              day: day,
              format: format,
              link: link,
              room: location,
              course: this.selectedCourse,
              // eslint-disable-next-line @typescript-eslint/camelcase
              programming_tutorial: programmingTut,
            };
            this.createdTutorials.push(newTutorial);
          } else {
            alert(
              alreadyExists
                ? "tutorial not created! One tutorial of this tutor in this time slot already exists"
                : "tutorial not created!"
            );
          }
        }
      });
  }

  constructor() {
    super();
    this.$axios.get("courses").then((req) => {
      if (req.data instanceof Array && req.data.length) {
        const courses = req.data;
        for (let i = 0; i < courses.length; i++) {
          const course: Course = {
            id: courses[i]["id"],
            startDate: courses[i]["start_date"],
            endDate: courses[i]["end_date"],
            name: courses[i]["name"],
          };
          this.currentCourse.push(course);
        }
      }
      if (this.currentCourse.length) {
        this.$axios
          .get("tutorials/get_course_tutorials/", {
            params: { course: this.latestCourse.id },
          })
          .then((req) => {
            for (const tutorial of req.data) {
              this.tutorials.push(tutorial);
            }
            this.tutorials.map((tutorial) => {
              if (this.tutorialsSelected[tutorial.responsible_tutor]) {
                this.tutorialsSelected[tutorial.responsible_tutor].push(
                  tutorial
                );
              } else {
                this.tutorialsSelected[tutorial.responsible_tutor] = [tutorial];
              }
            });
            if (this.tutorials.length) {
              this.showSelectionResult.value = true;
            } else {
              this.showTutorialGeneration.value = true;
            }

            this.$axios
              .get("tutor_sessions/get_participants_semester/", {
                params: {
                  // eslint-disable-next-line @typescript-eslint/camelcase
                  start_date: this.latestCourse.startDate,
                  // eslint-disable-next-line @typescript-eslint/camelcase
                  end_date: this.latestCourse.endDate,
                },
              })
              .then((req) => {
                if (req.data instanceof Array) {
                  for (let i = 0; i < req.data.length; i++) {
                    if (req.data[i]["date"]) {
                      req.data[i]["date"] = this.getWeekString(
                        req.data[i]["date"]
                      );
                    }
                    this.participantsSemester.push(req.data[i]);
                  }
                }
              });

            this.$axios
              .get(`courses/${this.latestCourse.id}/matching`)
              .then((res) => {
                res.data.forEach((e: any) => {
                  this.matchings.push(e);
                });
              });
          });
      }
      this.$axios.get("tutors").then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          this.tutorList.push(response.data[i]);
        }
      });
    });
  }

  // tutorial assignment -------------------------------------------------------------------------------

  readTutorsFile(event: InputEvent) {
    const tutorFile = this.tutorsFile;
    if (tutorFile) {
      const reader = new FileReader();
      reader.readAsText(tutorFile);
      const tutorsTemp: string[] = [];
      reader.onload = function (event) {
        if (event.target) {
          const lines = (event.target.result as string).trim().split(/\r\n|\r|\n/);
          for (let i = 0; i < lines.length; i++) {
            const line = lines[i].split(",");
            if (line && line[0]) {
              tutorsTemp.push(line[0]);
            }
          }
        }
      };
      this.tutors = tutorsTemp;
    }
  }

  readTutorialsFile(event: InputEvent) {
    const tutorialsFile = this.tutorialsFile;
    if (tutorialsFile) {
      const reader = new FileReader();
      reader.readAsText(tutorialsFile);
      const tutorialsTemp: string[][] = [];
      reader.onload = function (event) {
        if (event.target) {
          const lines = (event.target.result as string).trim().split(/\r\n|\r|\n/);
          for (let i = 1; i < lines.length; i++) {
            // TODO: split(';'), should be a comma, but the file i receive is split with semicolon, please discuss this with Martin
            const line = lines[i].split(";");
            if (line && line[0]) {
              tutorialsTemp.push(line);
            }
          }
        }
      };
      this.timeSlot = tutorialsTemp;
    }
  }

  parseTutorialTimeslotFromCSV(event: InputEvent) {
    const files = (event.target as HTMLInputElement).files;
    if (files && files.length == 1) {
      const tutorialsFile = files.item(0);
      if (tutorialsFile) {
        const reader = new FileReader();
        reader.readAsText(tutorialsFile);

        reader.onload = (event) => {
          if (event.target) {
            const lines = (event.target.result as string).trim().split(/\r\n|\r|\n/);
            for (let i = 1; i < lines.length; i++) {
              // TODO: split(';'), should be a comma, but the file i receive is split with semicolon, please discuss this with Martin
              const line = lines[i].split(";");
              if (line && line[0]) {
                this.timeslots.push({
                  day: line[0],
                  start: line[1],
                  end: line[2],
                  format: line[3] === "Online" ? "online" : "presence",
                  capacity: Number(line[4]),
                });
              }
            }
          }
        };
      }
    }
  }

  readSelectionFile(event: InputEvent) {
    const selectionFile = this.assignmentsFile;
    if (selectionFile) {
      const reader = new FileReader();
      reader.readAsText(selectionFile);
      const selectionTemp: string[][] = [];
      reader.onload = function (event) {
        if (event.target) {
          const lines = (event.target.result as string).trim().split(/\r\n|\r|\n/);
          for (let i = 1; i < lines.length; i++) {
            const line = lines[i].split(",");
            if (line && line[0]) {
              selectionTemp.push(line);
            }
          }
        }
      };
      this.selection = selectionTemp;
    }
  }

  showResult() {
    this.showSelectionResult.value = true;
    if (this.tutors.length && this.timeSlot.length && this.selection.length) {
      for (let i = 0; i < this.tutors.length; i++) {
        if (this.selection[i]) {
          for (let j = 0; j < this.selection[i].length; j++) {
            if (this.selection[i][j] == "1") {
              const tutorial: Tutorial = {
                name: this.timeSlot[j][0],
                // eslint-disable-next-line @typescript-eslint/camelcase
                responsible_tutor: this.tutors[i],
                day: this.timeSlot[j][1],
                start: this.timeSlot[j][2],
                end: this.timeSlot[j][3],
              };
              this.createdTutorials.push(tutorial);
            }
          }
        }
      }
    }

    this.createdTutorials.map((tutorial) => {
      if (this.tutorialsSelected[tutorial.responsible_tutor]) {
        this.tutorialsSelected[tutorial.responsible_tutor].push(tutorial);
      } else {
        this.tutorialsSelected[tutorial.responsible_tutor] = [tutorial];
      }
    });
  }

  readAllInOneFile() {
    const f = this.allInOneFile;
    if (f) {
      const tempTutorials: Tutorial[] = [];
      const reader = new FileReader();
      reader.readAsText(f);
      reader.onload = (event) => {
        if (event.target) {
          const lines = (event.target.result as string).trim().split(/\r\n|\r|\n/);
          for (let i = 0; i < lines.length; i++) {
            // TODO: split(';'), should be a comma, but the file i receive is split with semicolon, please discuss this with Martin
            const line = lines[i].split(";");
            const validatedLine = this.validateTutorialLine(line, i);
            if (validatedLine.length) {
              const tutorial: Tutorial = {
                name: line[0],
                format: line[1] === "Online" ? "ONLINE" : "PRESENCE",
                day: line[0].split("-")[0],
                start: line[2] === "8:00" ? "08:00" : line[2],
                end: line[3],
                room: line[4].includes("http") ? undefined : line[4],
                link: line[4].includes("http") ? line[4] : undefined,
                // eslint-disable-next-line @typescript-eslint/camelcase
                responsible_tutor: line[5],
                // eslint-disable-next-line @typescript-eslint/camelcase
                programming_tutorial: this.isProgrammingTutorial,
              };
              tempTutorials.push(tutorial);
            }
          }
          this.createdTutorials = tempTutorials;
        }
      };
    }
  }

  validateTutorialLine(line: string[], lineNr: number) {
    if (!(line.length == 6)) {
      alert(
        `Zeile ${
          lineNr + 1
        } ist nicht im Format (Name; Format; Beginn; Ende; Tutor) und wird nicht erzeugt`
      );
      return [];
    }

    //validate day
    const name = line[0].trim();
    const validDays = ["Mo", "Di", "Mi", "Do", "Fr"];
    const day = name.split("-")[0];
    if (!validDays.includes(day)) {
      alert(
        `Zeile ${lineNr}: Der Name muss mit 'Mo-', 'Di-', 'Mi-', 'Do-' oder 'Fr-' beginnen`
      );
      return [];
    }
    // validate format
    const validFormats = ["Online", "Präsenz", ""];
    const format = line[1].trim();
    if (!validFormats.includes(format)) {
      alert(
        `Zeile ${lineNr}: Das Format muss 'Online', 'Präsenz' oder leer sein`
      );
      return [];
    }

    // validate time
    const validTimes = [
      "8:00",
      "08:00",
      "10:00",
      "12:00",
      "14:00",
      "16:00",
      "18:00",
    ];
    const start = line[2].trim();
    const end = line[3].trim();
    if (!validTimes.includes(start)) {
      alert(
        `Zeile ${lineNr}: Der Beginn muss "08:00", "10:00", "12:00", "14:00", "16:00" oder "18:00" sein`
      );
      return [];
    }
    if (!validTimes.includes(end)) {
      alert(
        `Zeile ${lineNr}: Das Ende muss "08:00", "10:00", "12:00", "14:00", "16:00" oder "18:00" sein`
      );
      return [];
    }

    return line;
  }

  // route ----------------------------------------------------------------------------------------------

  saveTutorials() {
    if (this.createdTutorials.length) {
      this.$axios.post("tutorials/", this.createdTutorials).then((req) => {
        if (req.status == 201) {
          for (let i = 0; i < this.createdTutorials.length; i++) {
            this.tutorials.push(this.createdTutorials[i]);
          }
          this.createdTutorials = [];
        } else {
          alert("Create Tutorials Failed");
        }
      });
    }
  }

  toProfileView(tutor: string) {
    this.$router.push({
      name: "tutorials.profile",
      params: {
        username: tutor,
      },
    });
  }

  toCreateNewTutorialsViews() {
    this.$router.push({
      name: "tutorials.admin.addTutorials",
    });
  }

  toCourseAdminView() {
    this.$router.push({ name: "tutorials.admin.courses" });
  }

  // display --------------------------------------------------------------------------------------------
  localDateString(dateString: string): string {
    const date = new Date(dateString);
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    } as const;
    return date.toLocaleDateString("de-DE", options);
  }

  getWeeksOfCurrentCourse(
    startDateString: string,
    endDateString: string
  ): string[] {
    const startDate = this.getMonday(new Date(startDateString));
    const endDate = this.getMonday(new Date(endDateString));
    const oneDay = 1000 * 60 * 60 * 24;
    const diff = Math.abs((endDate.valueOf() - startDate.valueOf()) / oneDay);
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    } as const;
    const returnString = [];
    for (let i = 0; i <= diff; i = i + 7) {
      let d = this.getMonday(new Date(startDateString));
      const dayStringMonday = new Date(
        d.setDate(d.getDate() + i)
      ).toLocaleDateString("de-DE", options);
      d = this.getMonday(new Date(startDateString));
      const dayStringFriday = new Date(
        d.setDate(d.getDate() + i + 4)
      ).toLocaleDateString("de-DE", options);
      returnString.push(dayStringMonday + " ~ " + dayStringFriday);
    }
    return returnString;
  }

  // charts
  getMonday(d: Date): Date {
    const day = d.getDay();
    const diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
  }

  getMondayString(weekString: string): string {
    const words = weekString.split(" ");
    if (words[0]) {
      const date = words[0].split(".");
      return date[2] + "-" + date[1] + "-" + date[0];
    }
    return words[0];
  }

  getWeekString(mondayString: string): string {
    const monday = new Date(mondayString);
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    } as const;
    const returnMonday = monday.toLocaleDateString("de-DE", options);
    const returnFriday = new Date(
      monday.setDate(monday.getDate() + 4)
    ).toLocaleDateString("de-DE", options);
    return returnMonday + "~" + returnFriday;
  }

  headers = [
    {
      text: "ID",
      value: "id",
      width: "10%",
    },
    { text: "Name", value: "name", width: "20%" },
    { text: "Tutor", value: "tutor", width: "25%" },
    { text: "Wochentag", value: "day", width: "10%" },
    { text: "Beginn", value: "start", width: "10%" },
    { text: "Ende", value: "end", width: "10%" },
    { text: "", value: "controls", sortable: false, width: "15%" },
  ];

  getTutorialItems() {
    const tuts = [];
    for (let i = 0; i < this.tutorials.length; i++) {
      const tut = this.tutorials[i];
      tuts.push({
        id: tut.id,
        name: tut.name,
        tutor: tut.responsible_tutor,
        day: tut.day,
        start: tut.start,
        end: tut.end,
      });
    }
    return tuts;
  }
}
